jQuery(document).ready(function ($) {
  // console.log("Start Project")

  var screen =  $(window).width();
  var folder = screen  < 525 ? "sp" : "mv"; 

  var bgImageArray = [
    `/dist/images/${folder}/mv_1.jpg`,
    `/dist/images/${folder}/mv_2.jpg`,
    `/dist/images/${folder}/mv_3.jpg`,
    `/dist/images/${folder}/mv_4.jpg`,
    `/dist/images/${folder}/mv_5.jpg`,
    `/dist/images/${folder}/mv_6.jpg`,
    `/dist/images/${folder}/mv_7.jpg`,
    `/dist/images/${folder}/mv_8.jpg`,
    `/dist/images/${folder}/mv_9.jpg`,
    `/dist/images/${folder}/mv_10.jpg`,
    `/dist/images/${folder}/copy.svg`,
  ];

  bgImageArray.forEach(function (img) {
    new Image().src = ajax.files + img;
  });

  var secs = 1;

  function backgroundSequence() {
    window.clearTimeout();

    var elm = document.getElementById("home-slider");
   
    if(elm) {
      var k = 0;
      for (i = 0; i < bgImageArray.length; i++) {
        setTimeout(function () {
          elm.style.background =
            "url(" +
            ajax.files +
            bgImageArray[k] +
            ") no-repeat";
          elm.style.backgroundSize = "cover";
          if(k < 9) {
            k++
          }else {
            elm.classList.add("copy")
          }
        }, secs * 500 * i);
      }
    }
   
  }
  backgroundSequence();

  /**
   * Open Menu
   */

  $("#js-menu-open").click(function (e) {
    // e.preventDefault();
    $("#js-menu").toggleClass("show");
    $(".menu").toggleClass("active");
    $("body").toggleClass("no-scroll");
  });

  /**
   * Close Menu
   */
  $("#js-menu-close").click(function (e) {
    // e.preventDefault();
    $("#js-menu").removeClass("show");
    $(".menu").removeClass("active");
    $("body").removeClass("no-scroll");
  });

  /**
   * Set Page
   */
  // var scrollList = [];

  // $(window).on("load", function (e) {
  // scrollList.push($(".js-section").first().offset().top);
  // scrollList.push($(".js-section").last().offset().top);
  // // set input
  // $(".scroll input[type='range']").attr("min", scrollList[0]);
  // $(".scroll input[type='range']").attr("max", scrollList[1]);
  // // set val

  // $(".scroll input[type='range']").val(scrollList[0]);
  // });
  /**
   * Scroll Page
   */
  // $(".scroll input[type='range']").change(function (e) {
  //   e.preventDefault();
  //   // set input
  //   $(this).attr("min", scrollList[0]);
  //   $(this).attr("max", scrollList[1]);
  //   // scroll
  //   $("html, body").animate(
  //     {
  //       scrollTop: $(this).val(),
  //     },
  //     300
  //   );
  // });
  // $(window).scroll(function (event) {
  //   var scroll = $(window).scrollTop();
  //   $(".scroll input[type='range']").val(scroll);
  // });
  // F

  // 動きのきっかけとなるアニメーションの名前を定義
  function fadeAnime() {
    // ふわっ
    $(".js-section").each(function () {
      //fadeUpTriggerというクラス名が
      var elemPos = $(this).offset().top - 50; //要素より、50px上の
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll >= elemPos - windowHeight) {
        $(this).addClass("fadeUp"); // 画面内に入ったらfadeUpというクラス名を追記
      } else {
        $(this).removeClass("fadeUp"); // 画面外に出たらfadeUpというクラス名を外す
      }
    });
  }

  // 画面をスクロールをしたら動かしたい場合の記述
  $(window).scroll(function () {
    fadeAnime(); /* アニメーション用の関数を呼ぶ*/
  }); // ここまで画面をスクロールをしたら動かしたい場合の記述

  // 画面が読み込まれたらすぐに動かしたい場合の記述
  $(window).on("load", function () {
    fadeAnime(); /* アニメーション用の関数を呼ぶ*/
  }); // ここまで画面が読み込まれたらすぐに動かしたい場合の記述




  $("body").on("click", ".js-modal", function () {
    var elm = $(this);


    var idModal = elm.data("id");
    $.ajax({
      type: "get",
      dataType: "json",
      url: ajax.url,
      data: {
        action: "member_detail",
        id: idModal,
      },
      context: this,
      success: function (response) {
        $("#modal").html(response.data);
        $("#overlay").show();
        $("body").addClass("no-scroll");
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.log("The following error occured: " + textStatus, errorThrown);
      },
    });
    return false;
  });

  $("body").on("click", "#overlay", function () {
    $("#modal").html("");
    $("body").removeClass("no-scroll");
  });

  $(".checkbox__input input[type='checkbox']").change(function (e) { 
    e.preventDefault();
      var elm = $(this).is(":checked");
      if(elm) {
        $(".button-form input[type='submit']").attr("disabled" , false)
      }else {
        $(".button-form input[type='submit']").attr("disabled" , true)
      }
  });

  setTimeout(function() {
    $("body").on("click", ".button-close", function () {
      $("#modal").html("");
      $("body").removeClass("no-scroll");
    });
    
  },1000)


 

  $(".button-form__contact input[type='submit']").click(function(e){
    e.preventDefault();
    var lists = $(".input-require").toArray();
    lists.forEach((elm,index) => {
      if($(elm).val() == "") {
        $(elm).addClass("has-error")
      }else {
        $(elm).removeClass("has-error")
      }
    })
    var checkLists = $(".box-contact .input-require").toArray();

    checkLists.forEach((elm,index) => { 
      if(!$(elm).hasClass('has-error')) { 
        $("form").unbind('submit').submit()
      }
    })

  });



});

/**
 * JAVASCRIPT
 */


